import { ErrorText } from '~/constants';
import { useOverlayContext, useStoreActions } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { ServerError } from '~/infra/ErrorResponse';
import { handleRequest } from '~/infra/utils';
const loaderName = 'updateRelationship';
export function useUpdateRelationship() {
    const { api } = useStoreActions();
    const { startLoader, stopLoader, showErrorToast, showSuccessToast } = useOverlayContext();
    const { START_BILLING_AT, START_BILLING_AT_PHASE_2_INLINE } = useFeatureFlags();
    const startBillingAtEnabled = START_BILLING_AT || START_BILLING_AT_PHASE_2_INLINE;
    return async function updateRelationship(param) {
        let { id, version, changes, onSuccess } = param;
        startLoader(loaderName);
        const updateResult = await handleRequest(startBillingAtEnabled ? api.relationship.update(id, {
            version,
            changes
        }) : api.relationship.updateOld(id, {
            version,
            changes
        }));
        if (!updateResult.success) {
            showErrorToast(updateResult.error.hasServerError(ServerError.MismatchingRelationshipVersion) ? ErrorText.MismatchingRelationshipVersion : ErrorText.UnexpectedErrorTryAgain, 'edit-agr-error');
            return stopLoader(loaderName);
        }
        onSuccess && await onSuccess();
        showSuccessToast('Changes saved successfully', 'edit-agr-success');
        stopLoader(loaderName);
    };
}
